import { apiClient } from '../client'
import type { ApiSuccessResponse } from '../../types/api'
import type { DashboardStats } from '../../types/dashboard'

/** Role-scoped dashboard KPIs — components call this service only. */
export const dashboardService = {
  async getStats() {
    const { data } = await apiClient.get<ApiSuccessResponse<DashboardStats>>('/dashboard/stats')
    return data
  },
}
